import { AppState } from '../store';
import { createSelector } from '@reduxjs/toolkit';

export type ClientUserProfilePresentation = {
  id?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNrCountry?: string;
  phoneNumber?: string;
  hasError: boolean;
};

const getClientSettingsState = (state: AppState) => state.clientSettings;

export const selectClientUserProfilePresentation = createSelector([getClientSettingsState], (clientSettings) => {
  return {
    id: clientSettings.clientProfileInfo?.id,
    firstName: clientSettings.clientProfileInfo?.firstName,
    lastName: clientSettings.clientProfileInfo?.lastName,
    phoneNumber: clientSettings.clientProfileInfo?.phoneNumber,
    email: clientSettings.clientProfileInfo?.email,
    phoneNrCountry: clientSettings.clientProfileInfo?.countryDialCode,
    hasError: clientSettings.loadingDataError !== undefined,
  } as ClientUserProfilePresentation;
});
